import { render, staticRenderFns } from "./ApprovalSetting.vue?vue&type=template&id=1e6567ad&"
import script from "./ApprovalSetting.vue?vue&type=script&lang=js&"
export * from "./ApprovalSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports